import { createSelector } from 'reselect';
const getState = state => state.hubContact;
export const getIsHubContact = createSelector([getState], state => state.get('isHubContact'));